import clsx from 'clsx'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import SydButton from '../../../../../commonDesign/Button'
import Icon from '../../../../../atoms/Icon'
import { usePreviewDisplayContext } from '../PreviewDisplayContext'

const useStyles = makeStyles((theme) => ({
  templateContentPageNavigation: {
    display: 'flex',
    flex: '1 0',
    width: 'fit-content',
    gap: '1rem',
    flexDirection: 'column',
    padding: '1rem 0',
    margin: '0 -1px 0 0',
    alignItems: 'flex-end'
  },
  pageButtonContainer: {
    position: 'relative'
  },
  pageButton: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    paddingRight: '1em',
    borderRight: '0px',
    minWidth: '6.5rem',
    transition: 'all 0.2s ease-in-out',
    '&.active': {
      fontWeight: '700',
      paddingLeft: '3rem',
      paddingRight: '2.5rem'
    }
  },
  pageDeleteButton: {
    position: 'absolute',
    width: '1.5em',
    minWidth: '1.6rem',
    height: '1.6rem',
    padding: 0,
    top: '-.75rem',
    left: '-.75rem',
    background: 'var(--color-danger-300)',
    '& svg': {
      width: '.7em',
      height: '.85em',
      color: 'var(--color-danger-050)'
    }
  }
}))

export const TemplatePageNavigation = () => {
  const classes = useStyles()
  const { setValue, watch } = useFormContext()
  const { setCurrentPageIndex, setSelectedBlock, currentPageIndex } = usePreviewDisplayContext()
  const templateContent = watch('content')

  const appendNewPage = () => {
    const newValues = {
      ...templateContent,
      pages: [...templateContent.pages, { blocks: [] }]
    }
    setValue('content', newValues)
    setCurrentPageIndex(newValues?.pages?.length - 1)
    setSelectedBlock(null)
  }

  const deletePage = (index) => {
    const newValues = {
      ...templateContent,
      pages: templateContent.pages.filter((_, i) => i !== index)
    }
    setValue('content', newValues)
    if (currentPageIndex === index) {
      setCurrentPageIndex(0)
    }
  }

  return (
    <div className={classes.templateContentPageNavigation}>
      {Array.from({ length: templateContent.pages?.length || 0 }).map((_, i) => (
        <div
          key={i}
          className={classes.pageButtonContainer}
        >
          <SydButton
            type='button'
            onClick={() => setCurrentPageIndex(i)}
            className={clsx(
              classes.pageButton,
              currentPageIndex === i ? 'active' : ''
            )}
            variant={currentPageIndex === i ? 'primary' : 'secondary'}
          >
            Page {i + 1}
          </SydButton>
          {!templateContent.pages[i]?.blocks?.length && (
            <SydButton
              size='xs'
              type='button'
              priority='warning'
              variant='primary'
              className={classes.pageDeleteButton}
              onClick={() => deletePage(i)}
            >
              <Icon name='delete' customSize={24} />
            </SydButton>
          )}
        </div>
      ))}
      <SydButton
        type='button'
        variant='secondary'
        size='sm'
        className={classes.pageButton}
        onClick={appendNewPage}
        icon='add'
      >
        Page
      </SydButton>
    </div>
  )
}
